// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"styles_loadingSpinner__32AVW","spin":"styles_spin__34Ew8"};